export type ReservationTagSlot = {
  id: number
  slug: string
  l_order: number
  color_bg: string
  color_border: string
  default_name: string
  name: string
  is_hidden: boolean
}

export type ReservationTagsRes = ReservationTagSlot[]

export const GET_RESERVATION_TAGS = '/v2/pms/reservation-tags/'
